import { searchParam } from '@luminovo/design-system';
import { createFileRoute, notFound } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import AttachAdditionalFilesPage from '@/areas/quote-requests/QuoteRequests/AttachAdditionalFilesPage/AttachAdditionalFilesPage';
import { quoteRequestsBelongTo } from '@/domain/quoteRequest/quoteRequestHandler';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The page shows the quote requests in the project's sidebar, and its links lead within the project. Quote requests of
// another project or of a negotiation, which only a hand-edited URL brings, render the not-found page.
export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: z.object({ quoteRequestIds: searchParam.list('required') }),
    loaderDeps: ({ search }) => ({ quoteRequestIds: search.quoteRequestIds }),
    loader: async ({ context: { queryClient }, params: { projectId }, deps: { quoteRequestIds } }) => {
        if (!(await quoteRequestsBelongTo(queryClient, quoteRequestIds, { type: 'Rfq', id: projectId }))) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { projectId } = Route.useParams();
    const quoteRequestIds = Route.useSearch({ select: (search) => search.quoteRequestIds });
    return <AttachAdditionalFilesPage context={{ type: 'Rfq', id: projectId }} quoteRequestIds={quoteRequestIds} />;
}
